import React, { useContext, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';

import * as S from './DockLikuConnect.style';

import { RootStoreContext } from '../../../App';
import Image from '../../image/Image';
import { useLocation } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const CONTENT_PLAYING_TOOLTIP =
	'컨텐츠가 재생중입니다. 종료 후 다시 시도해 주세요';

const DockLikuConnect = observer((props) => {
	const { controller, music, isContentPlaying = false } = props;
	const { likuStore } = useContext(RootStoreContext);

	const [isHovering, setIsHovering] = useState(false);
	const controllerRef = useRef(null);
	const musicRef = useRef(null);

	const location = useLocation();

	const disconnect = () => {
		likuStore.setThisLiku();
		controller.onClick(false);
		music.onClick(false);
	};

	useEffect(() => {
		controller.onClick(false);
		music.onClick(false);
	}, [location.pathname]);

	return (
		<S.Content>
			<S.LikuWrap>
				{isHovering && (
					<S.Serial>
						<p>{likuStore.thisLiku.serial}</p>
						<p>v{likuStore.thisLiku?.version?.likuVer || ''}</p>
					</S.Serial>
				)}
				<S.Mind
					onMouseOver={() => setIsHovering(true)}
					onMouseOut={() => setIsHovering(false)}>
					<div></div>
					<div>
						<div></div>
						<div></div>
						<div></div>
					</div>
					{isHovering && (
						<S.DisconnectButton onClick={() => disconnect()}>
							{/*<div>*/}
							<Image srcArray={S.unlink_list} />
							연결해제
							{/*</div>*/}
						</S.DisconnectButton>
					)}
				</S.Mind>
			</S.LikuWrap>
			<S.Controls>
				<S.MenuTooltipAnchor
					data-tooltip-id='content-playing-dock-tooltip'
					data-tooltip-content={
						isContentPlaying ? CONTENT_PLAYING_TOOLTIP : undefined
					}>
					<S.Menu
						ref={musicRef}
						className='music'
						click={music.click}
						disabled={isContentPlaying}
						onClick={() => music.onClick()}>
						<Image srcArray={S.music_list} />
					</S.Menu>
				</S.MenuTooltipAnchor>
				<S.MenuTooltipAnchor
					data-tooltip-id='content-playing-dock-tooltip'
					data-tooltip-content={
						isContentPlaying ? CONTENT_PLAYING_TOOLTIP : undefined
					}>
					<S.Menu
						ref={controllerRef}
						className='controller'
						click={controller.click}
						disabled={isContentPlaying}
						onClick={() => controller.onClick()}>
						<Image srcArray={S.controller_list} />
					</S.Menu>
				</S.MenuTooltipAnchor>
			</S.Controls>
			<Tooltip id='content-playing-dock-tooltip' place='top' />
			{/* <S.Line /> */}
			{/* <S.Menu className='favorites'>
				<Image srcArray={S.favorites_list} />
			</S.Menu> */}
		</S.Content>
	);
});

export default DockLikuConnect;
